import ArticleLayout from '@/components/feature/ArticleLayout';

export default function HoodiesArticle() {
  return (
    <>
      <title>Superbuy Spreadsheet Hoodies &amp; Sweaters: The Ultimate Guide to Finding Quality Knitwear</title>
      <meta name="description" content="Complete guide to Superbuy Spreadsheet hoodies and sweaters — fabric weight guides, seasonal picks, sizing tips, and the best knitwear finds across the organized spreadsheet collections. Updated 2026." />
      <meta name="keywords" content="superbuy spreadsheet hoodies, superbuy sheet sweaters, superbuy hoodie spreadsheet, best superbuy hoodies, superbuy sweatshirt guide, superbuy spreadsheet knitwear" />
      <link rel="canonical" href={`${import.meta.env.VITE_SITE_URL || 'https://superbuyspread.makeup'}/superbuy-spreadsheet-hoodies`} />
      <ArticleLayout slug="superbuy-spreadsheet-hoodies" />
    </>
  );
}